module.exports = __webpack_public_path__ + "img/72.20190f96.webp";